module.exports = __webpack_public_path__ + "img/doc-avatar-male.93e37aea.png";